/**
 * Get the correct backend URL based on environment
 * Auto-detects production domain and uses same origin to avoid CORS issues
 */
export const getBackendURL = () => {
  const hostname = window.location.hostname;
  
  // If on production domain, use same origin (fixes CORS issues)
  if (hostname === 'getmealguide.com' || hostname === 'www.getmealguide.com') {
    return window.location.origin;
  }
  
  // Otherwise use env variable or fallback to same origin
  return process.env.REACT_APP_BACKEND_URL || window.location.origin;
};

export const BACKEND_URL = getBackendURL();
export const API = `${BACKEND_URL}/api`;
